import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

import { ErrorSmallComponent } from '@components/error-handling/error-small/error-small.component';

import { NavigationService } from '@services/navigation.service';
import { ErrorStore } from '@cxc/core/services';

@Component({
  selector: 'error-component',
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    AccordionModule,
    ErrorSmallComponent,
  ],
})
export class ErrorComponent {
  constructor(
    public navigationService: NavigationService,
    public errorStore: ErrorStore,
    private router: Router
  ) {}

  resolution() {
    this.router.navigateByUrl(this.errorStore.resolution().url!);
  }
}
